import { render, staticRenderFns } from "./SortManagementDetail.vue?vue&type=template&id=26fe4841&"
import script from "./SortManagementDetail.vue?vue&type=script&lang=js&"
export * from "./SortManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./SortManagementDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports